import {
  FulfilmentLocationInput,
  LocationType,
} from '../../../../graphql-types'
import { NonBasketOutletFulfilment } from '../validation'

export const currentFulfilmentToLocationInput = (
  currentFulfilment?: NonBasketOutletFulfilment['currentFulfilment']
): FulfilmentLocationInput | null => {
  switch (currentFulfilment?.type) {
    case 'COORDINATES':
      return {
        type: LocationType.COORDINATES,
        coordinates: currentFulfilment.coordinates,
      }
    case 'DELIVERY_ZONE':
      return {
        type: LocationType.DELIVERY_ZONE,
        deliveryZoneId: currentFulfilment.zoneId,
      }
    case 'PLACE_SEARCH':
      return {
        type: LocationType.PLACE_SEARCH,
        placeId: currentFulfilment.placeId,
      }
    case 'POSTCODE':
      return {
        type: LocationType.POSTCODE,
        postAndCountryCode: currentFulfilment.postAndCountryCode,
      }
    case 'SAVED_ADDRESS':
      return {
        type: LocationType.ADDRESS,
        addressId: currentFulfilment.addressId,
      }
    // all other currentFulfilment types map to EVERYWHERE as they don't care about location (eg COLLECTION / TABLE)
    default:
      return { type: LocationType.EVERYWHERE }
  }
}
